import { isArray } from "lodash-es";

export const getValues = (arr) => (isArray(arr) ? arr.join(",") : arr);

export const optimizeDatesArray = (arr) =>
  arr.filter(({ from, to }) => !!from && !!to);

export const optimizeTimesArray = (arr) =>
  arr.filter(({ Times: { from, to } }) => !!from && !!to);
